export default __webpack_public_path__ + "static/media/newyear4.c4ace30c.png";